import React, { useState, useEffect } from "react";

const TypingBubble = () => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => {
        if (prevDots.length === 3) {
          return "";
        } else {
          return prevDots + ".";
        }
      });
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="flex items-center w-full">
      <div className="rounded-lg w-full">
        <span className="text-blue-500">Processing{dots}</span>
      </div>
    </div>
  );
};

export default TypingBubble;
